// File generated automatically, do not modify

import axios from "axios";
import { AsyncTaskInfo } from "./models";

const paths = {
  status: "api/AsyncTasks/Status",
  cancel: "api/AsyncTasks/Cancel",
};

interface StatusParams {
  taskId?: string;
}

function status(params: StatusParams): Promise<AsyncTaskInfo> {
  return axios
    .request<AsyncTaskInfo>({
      url: paths.status,
      method: "get",
      params,
    })
    .then(res => res.data);
}

interface CancelParams {
  taskId?: string;
}

function cancel(params: CancelParams): Promise<AsyncTaskInfo> {
  return axios
    .request<AsyncTaskInfo>({
      url: paths.cancel,
      method: "post",
      params,
    })
    .then(res => res.data);
}

export const asyncTasksService = {
  paths,
  status,
  cancel,
};
